import React from 'react'

import Image from '../atoms/Image'

type Props = {
  className?: string
  color: 'gray' | 'pink'
  direction: 'top' | 'right' | 'bottom'
}

export default function Angle({ className, color, direction }: Props) {
  return <Image alt="矢印" className={className} filename={`icon-angle-${color}-${direction}.png`} />
}
